import { render, staticRenderFns } from "./DetailsSummary.vue?vue&type=template&id=6ec9aae6&scoped=true&"
import script from "./DetailsSummary.vue?vue&type=script&lang=js&"
export * from "./DetailsSummary.vue?vue&type=script&lang=js&"
import style0 from "./DetailsSummary.vue?vue&type=style&index=0&id=6ec9aae6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec9aae6",
  null
  
)

export default component.exports